import PropTypes from 'prop-types';
import React from 'react';

const Icon = ({ className, size, id }) => (
  <svg
    className={`icon icon--${id}  ${size ? `icon--${size}` : ''} ${className}`}
  >
    <use xlinkHref={`#${id}`} />
  </svg>
);

Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  id: PropTypes.string.isRequired
};

Icon.defaultProps = {
  className: '',
  size: 'small'
};

export default Icon;
